import {Cart} from '@shopify/hydrogen';
import {config} from '../config';
import {ProductVariant} from '@shopify/hydrogen/storefront-api-types';
import {REWARDS_IB_DISCOUNT_PERCENTAGE, REWARDS_IB_TAG} from '../constants';
import {getShopifyProductVariantMetafields} from './variants';

export function calculateRewardsCartInfo(
  lines: Cart['lines'],
  totalAmount: Cart['cost']['totalAmount']['amount'],
): {
  points: number;
  discount: number;
} {
  const points = Math.floor(Number(totalAmount));
  let discount = 0;
  let twl_shop_cost = 0;
  for (const line of lines) {
    const totalAmount = Number(line.cost.totalAmount.amount);
    // Skip lines with invalid totalAmount
    if (isNaN(totalAmount)) continue;
    const tags = (
      line.merchandise.product as typeof line.merchandise.product & {
        tags: string[];
      }
    ).tags;
    const shopId = (
      line.merchandise as typeof line.merchandise & {
        shopId: {value: string} | null;
      }
    ).shopId?.value;
    if (shopId === config.twlShopId) {
      twl_shop_cost += totalAmount;
      if (tags.includes(REWARDS_IB_TAG)) {
        discount += REWARDS_IB_DISCOUNT_PERCENTAGE * totalAmount; // 20% off twl-ib
      } else if (tags.includes('TWL Recommended')) {
        discount += 0.1 * totalAmount; // 10% off The Classics/TWL Recommended
      }
    }
    if (tags.includes('Show Ticket')) {
      discount += 0.2 * totalAmount;
    } else if (tags.includes('Virtual Tasting') && totalAmount > 10) {
      discount += 10; // $10 off virtual tastings
    }
  }
  if (twl_shop_cost > 0 && twl_shop_cost < 200) {
    discount += 15; // free shipping for rewards members
  }
  return {
    points,
    discount,
  };
}

export function calculateRewardsIbSaveAmount(
  variants: ProductVariant[],
): number | null {
  const twlShopVariant = variants.find(
    (variant) =>
      variant.availableForSale &&
      getShopifyProductVariantMetafields(variant.metafields).shopId ===
        config.twlShopId,
  );
  const price = Number(twlShopVariant?.price.amount);
  if (twlShopVariant && !isNaN(price)) {
    return price * REWARDS_IB_DISCOUNT_PERCENTAGE;
  }
  return null;
}
